<div *ngIf="!connected">
  <div class="info">
    <div class="POS-logo" style="height: 45px; width: 100px; background-size: contain; background-repeat: no-repeat; "
         [ngStyle]="{'background-image': 'url(../../../../../../assets/pos/Square-logo.jpg)'}" ></div>
    <!-- <div class="pos-title">Lightspeed</div> -->
    <div class="write-up">

    </div>
  </div>
</div>

<!--<button type="button" (click)="SaveSettings()" class="btn btn-primary" *ngIf="!busy && !connected">Connect to Square</button>-->
<div *ngIf="busy" style="display: block; margin-left: auto;text-align: right;">
  <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4" fill="transparent"
                     animationDuration=".5s">
  </p-progressSpinner>
</div>


<div *ngIf="connected" class="margin-top-16">
  <div style="font-size: 13px; text-align: center;">{{'onboarding.messages.pos_connected_info' | translate}}</div>
  <app-square-defaults *ngIf="connected" [partner]="partner" ></app-square-defaults>
</div>
